const customJsSelectBox =  {
    init: function () {

        let self = this;
        document.addEventListener("click", self._closeAllSelect);

        self._behaviourSelectBox();
    },

    _behaviourSelectBox() {
        let x, i, j, l, ll, selElmnt, a, b, c, e;
        let self = this;
        /*look for any elements with the class "custom-select":*/

        x = document.querySelectorAll(".js-custom-select:not(.js-select-initialized)");
        l = x.length;


        for (i = 0; i < l; i++) {

            selElmnt = x[i];
            ll = selElmnt.length;
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            e = document.createElement('DIV');
            e.setAttribute('class', 'c-custom-select');

            x[i].parentElement.append(e);
            a.setAttribute("class", "c-select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            e.appendChild(a);
            x[i].classList.add('js-select-initialized');
            //e.style.width = x[i].offsetWidth;
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "js-select-items c-select-items c-select-hide");
            if (x[i].disabled) {
                e.classList.add('c-custom-select--disabled');
                continue;
            }

            for (j = 0; j < ll; j++) {
                /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
                c = document.createElement("DIV");
                c.innerHTML = selElmnt.options[j].innerHTML;


                c.addEventListener("click", function(e) {
                    /*when an item is clicked, update the original select box,
                    and the selected item:*/
                    var y, i, k, s, h, sl, yl;
                    s = this.closest('.c-custom-select').parentElement.getElementsByTagName("select")[0];
                    sl = s.length;
                    h = this.parentNode.previousSibling;


                    for (i = 0; i < sl; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {
                            s.selectedIndex = i;
                            if ("createEvent" in document) {
                                var evt = document.createEvent("HTMLEvents");
                                evt.initEvent("change", false, true);
                                s.dispatchEvent(evt);
                            }
                            else {
                                s.fireEvent("onchange");
                            }

                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName("c-same-as-selected");
                            yl = y.length;
                            for (k = 0; k < yl; k++) {
                                y[k].removeAttribute("class");
                            }
                            this.setAttribute("class", "c-same-as-selected");
                            break;
                        }
                    }
                    h.click();
                });
                b.appendChild(c);
            }


            e.appendChild(b);
            //console.log(document.querySelector('.c-product-detail__item-select-wrapper').offsetWidth);

            //e.style.width = e.offsetWidth + 5  + 'px';
            b.classList.add('c-select-items');
            b.classList.add('c-select-hide');
            b.classList.remove('js-select-items');

            a.addEventListener("click", function(f) {
                /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
                f.stopPropagation();
                self._closeAllSelect(this);
                this.nextSibling.classList.toggle("c-select-hide");
                this.classList.toggle("c-select-arrow-active");
            });
        }

    },

    _closeAllSelect(element) {
        /*a function that will close all select boxes in the document,
            except the current select box:*/

        let x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("c-select-items");
        y = document.getElementsByClassName("c-select-selected");
        xl = x.length;
        yl = y.length;

        for (i = 0; i < yl; i++) {
            if (element == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("c-select-arrow-active");
            }
        }

        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("c-select-hide");
            }
        }
    }
};

customJsSelectBox.init();


document.addEventListener('LokiRequestEnd', function () {
    customJsSelectBox.init();
});